import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  treeViewSetSelectedListExpandedReducerType,
  treeViewSetTaxonomiesReducerType,
  treeViewSetSelectedTaxonomiesReducerType,
  treeViewSetInitialConfigReducerType,
} from './TreeViewConstants';

export const initialState = Map({
  taxonomies: [],
  selectedTaxonomies: [],
  selectedListExpanded: false,
  initialConfig: null,
});

const spec = {
  [treeViewSetTaxonomiesReducerType]: (state, action) => {
    const { taxonomies } = action.payload;
    return state.set('taxonomies', taxonomies);
  },
  [treeViewSetSelectedTaxonomiesReducerType]: (state, action) => {
    const { selectedTaxonomies } = action.payload;
    return state.set('selectedTaxonomies', selectedTaxonomies);
  },
  [treeViewSetSelectedListExpandedReducerType]: (state, action) => {
    const { selectedListExpanded } = action.payload;
    return state.set('selectedListExpanded', selectedListExpanded);
  },
  [treeViewSetInitialConfigReducerType]: (state, action) => {
    const { initialConfig } = action.payload;
    return state.set('initialConfig', initialConfig);
  },
};

export default createReducerBySpec(spec, initialState);
